import * as DismissedBandwidthBannersSlice from '@frontend/redux/slices/dismissedBandwidthBannersSlice';
import { useDispatch } from 'react-redux';
import type { BaseRootState } from './helpers';
import { useSelector } from './useSelector';

export const useDismissedBandwidthBannersSlice = <
  TRootState extends Pick<BaseRootState, 'dismissedBandwidthBanners'>,
>() => {
  const dispatch = useDispatch();

  const { dismissedBandwidthBanners } = useSelector<TRootState>()(
    ({ dismissedBandwidthBanners }) => dismissedBandwidthBanners,
  );

  const dismissBandwidthBanner = (id: string) => dispatch(DismissedBandwidthBannersSlice.dismissBandwidthBanner(id));

  const undismissBandwidthBanner = (id: string) =>
    dispatch(DismissedBandwidthBannersSlice.undismissBandwidthBanner(id));

  const clearDismissedBandwidthBanners = () =>
    dispatch(DismissedBandwidthBannersSlice.clearDismissedBandwidthBanners());

  return {
    clearDismissedBandwidthBanners,
    dismissBandwidthBanner,
    dismissedBandwidthBanners,
    undismissBandwidthBanner,
  };
};
